import { CHAT_CLASS_NAME } from '../../../models/chat'
import { FEEDBACK_MODEL_CLASS_NAME } from '../../../models/feedback'
import { FEEDBACK_REPLY_MODEL_CLASS_NAME } from '../../../models/feedback-reply'
import { CHATS_DOMAIN } from '../../chat'
import { CREATOR_CLIENT_CLASS_NAME } from '../../creator-client/model/constants'
import { CREATOR_CLIENTS_DOMAIN } from '../../creator-client/state/constants/domain'
import { DAY_CLASS_NAME, DAYS_DOMAIN } from '../../day'
import { EXERCISE_CLASS_NAME } from '../../exercise'
import { EXERCISE_LOG_SUMMARIES_DOMAIN } from '../../exercise-log-summaries/constants'
import { EXERCISE_LOGS_DOMAIN } from '../../exercise-logs/constants'
import { FEEDBACK_REPLIES_DOMAIN } from '../../feedback-replies/constants'
import { FEEDBACK_DOMAIN } from '../../feedback/constants'
import { MEDIA_DOMAIN, MEDIA_MODEL_CLASS_NAME } from '../../media'
import { MESSAGE_CLASS_NAME, MESSAGES_DOMAIN } from '../../message'
import { PLAN_CLASS_NAME } from '../../plan'
import PLANS_DOMAIN from '../../plans/constants/domain'
import { POST_CLASS_NAME } from '../../post/model/constants'
import POSTS_DOMAIN from '../../posts/constants/domain'
import { PREFERENCES_DOMAIN } from '../../preferences/constants'
import { PROFILE_LOG_CLASS_NAME } from '../../profile-log'
import { PROFILE_LOGS_DOMAIN } from '../../profile-logs/constants/domain'
import { PROFILE_CLASS_NAME } from '../../../models/profile/constants'
import { SETTINGS_DOMAIN } from '../../settings/constants'
import { USERS_DOMAIN } from '../../user/redux/constants'
import { WORKOUT_CLASS_NAME } from '../../workout'
import { WORKOUT_EXERCISE_CLASS_NAME } from '../../workout-exercise/model/constants'
import WORKOUT_EXERCISES_DOMAIN from '../../workout-exercise/redux/constants/domain'
import { WORKOUT_SECTION_CLASS_NAME } from '../../workout-section'
import WORKOUT_SECTIONS_DOMAIN from '../../workout-section/redux/constants/domain'
import WORKOUTS_DOMAIN from '../../workout/redux/constants/domain'
import { PREFERENCES_MODEL_CLASS_NAME } from '../../preferences'
import { SETTINGS_MODEL_CLASS_NAME } from '../../settings'
import { ACHIEVEMENT_CLASS_NAME, ACHIEVEMENTS_DOMAIN } from '../../achievement'
import { HIGHLIGHT_DOMAIN } from '../../highlight/redux/constants'
import { HIGHLIGHT_MODEL_CLASS_NAME } from '../../highlight'
import { EXERCISES_DOMAIN } from '../../exercise/redux/constants'
import { REPORT_CLASS_NAME } from '../../report/model/constants'
import { REPORTS_DOMAIN } from '../../report/redux/constants'
import { ABOUT_MODEL_CLASS_NAME } from '../../about/model/constants'
import { ABOUTS_DOMAIN } from '../../about/redux/constants'
import { EXERCISE_LOG_CLASS_NAME } from '../../exercise-log/model/constants'
import { EXERCISE_LOG_SUMMARY_CLASS_NAME } from '../../exercise-log-summary/model/constants'
import { USER_CLASS_NAME } from '../../user/model/constants'
import { MEAL_MODEL_CLASS_NAME, MEALS_DOMAIN } from '../../meal'
import { PROFILES_DOMAIN } from '../../profile/redux/constants'

const REDUX_DOMAIN = {
  [ACHIEVEMENT_CLASS_NAME]: ACHIEVEMENTS_DOMAIN,
  [HIGHLIGHT_MODEL_CLASS_NAME]: HIGHLIGHT_DOMAIN,
  [CREATOR_CLIENT_CLASS_NAME]: CREATOR_CLIENTS_DOMAIN,
  [ABOUT_MODEL_CLASS_NAME]: ABOUTS_DOMAIN,
  [EXERCISE_CLASS_NAME]: EXERCISES_DOMAIN,
  [CHAT_CLASS_NAME]: CHATS_DOMAIN,
  [DAY_CLASS_NAME]: DAYS_DOMAIN,
  [EXERCISE_LOG_CLASS_NAME]: EXERCISE_LOGS_DOMAIN,
  [EXERCISE_LOG_SUMMARY_CLASS_NAME]: EXERCISE_LOG_SUMMARIES_DOMAIN,
  [FEEDBACK_MODEL_CLASS_NAME]: FEEDBACK_DOMAIN,
  [FEEDBACK_REPLY_MODEL_CLASS_NAME]: FEEDBACK_REPLIES_DOMAIN,
  [MESSAGE_CLASS_NAME]: MESSAGES_DOMAIN,
  [MEAL_MODEL_CLASS_NAME]: MEALS_DOMAIN,
  [MEDIA_MODEL_CLASS_NAME]: MEDIA_DOMAIN,
  [POST_CLASS_NAME]: POSTS_DOMAIN,
  [PREFERENCES_MODEL_CLASS_NAME]: PREFERENCES_DOMAIN,
  [PROFILE_CLASS_NAME]: PROFILES_DOMAIN,
  [PROFILE_LOG_CLASS_NAME]: PROFILE_LOGS_DOMAIN,
  [PLAN_CLASS_NAME]: PLANS_DOMAIN,
  [PROFILE_LOG_CLASS_NAME]: PROFILE_LOGS_DOMAIN,
  [SETTINGS_MODEL_CLASS_NAME]: SETTINGS_DOMAIN,
  [USER_CLASS_NAME]: USERS_DOMAIN,
  [REPORT_CLASS_NAME]: REPORTS_DOMAIN,
  [WORKOUT_CLASS_NAME]: WORKOUTS_DOMAIN,
  [WORKOUT_EXERCISE_CLASS_NAME]: WORKOUT_EXERCISES_DOMAIN,
  [WORKOUT_SECTION_CLASS_NAME]: WORKOUT_SECTIONS_DOMAIN
}

export default REDUX_DOMAIN
